// export const API_BASE = 'http://localhost:8083/';
// export const API_BASE = 'https://amanda-scheduler-backend.herokuapp.com/';
export const API_BASE = process.env.REACT_APP_API_URL;
